import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const DATATEAMMEMBERS = () => {
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='team-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>DATA TEAM MEMBERS - IQAC</h1>
        </div>
      </div>

      {/* Team Members Details */}

      <div className='team-details'>
        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/shahul.png' className='team-img' />

          <div className='team-base'>
            <h3>Dr. A. Shahul Hameed</h3>
            <p></p>
            <p>IQAC Member & Associate Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of English</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/abdul.png' className='team-img' />

          <div className='team-base'>
            <h3>Dr. M. Abdul Jamal</h3>
            <p></p>
            <p>IQAC Member & Associate Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Economics</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/syed.png' className='team-img' />

          <div className='team-base'>
            <h3>Dr. Syed Shakir Razvi</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Corporate Secretaryship</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/muhammed.png' className='team-img' />

          <div className='team-base'>
            <h3>Dr. U. Muhammed Rafi</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Chemistry</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/akbar.png' className='team-img' />

          <div className='team-base'>
            <h3>Mr. S. K. Akbar Basha</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Computer Science</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/thameem.png' className='team-img' />

          <div className='team-base'>
            <h3>Dr. M. R. Thameem Ansari</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Arabic</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/thameemul.png' className='team-img' />

          <div className='team-base'>
            <h3>Mr. M. Thameemul Ansari</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Sociology</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/arshad.png' className='team-img' />

          <div className='team-base'>
            <h3>Mr. A. Arshad Ahmed</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Computer Applications</p>
          </div>

        </div>

        <div className='team-mem'>
          <img src='https://thenewcollege.edu.in/images/m-arshad.png' className='team-img' />

          <div className='team-base'>
            <h3>Mr. F. Mohammed Arshad</h3>
            <p></p>
            <p>IQAC Member & Assistant Professor</p>
            <p></p>
            <p></p>
            <p className='team-dept'>Department of Computer Science</p>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default DATATEAMMEMBERS;
